import { apiFetch } from "../../../../../app/apiClient.js";
import { teamActivities, dashboardModules, employmentTypes, permittedLanguageNames, enumToOptions } from "../../../../../app/utils/enums.js";

export function createDropdownInit(loadOptions, getValue) {
    return async (element, data = null) => {
        element.setOptions(await loadOptions());
        const value = getValue ? getValue(data) : undefined;
        const hasValue = Array.isArray(value) ? value.length > 0 : (value !== null && value !== undefined);
        if (hasValue) element.setValue(value, { silent: true });
    };
}

export const setupRoleDropdown = createDropdownInit(
    async () => (await apiFetch("roles")) ?? []
);
export const setupTeamDropdown = createDropdownInit(
    async () => (await apiFetch("teams")) ?? []
);
export const setupLanguageDropdown = createDropdownInit(
    async () => enumToOptions(permittedLanguageNames),
    data => data?.language != null ? String(data.language) : "1"
);
export const setupProjectsDropdown = createDropdownInit(
    async () => ((await apiFetch("Projects")) ?? []).map(project => ({ id: project.id, name: project.name })),
    data => data?.projectIds?.map(String)
);
export const setupDashboardModulesDropdown = createDropdownInit(
    async () => enumToOptions(dashboardModules),
    data => data?.dashboardModules?.map(String)
);
export const setupPermittedLanguagesDropdown = createDropdownInit(
    async () => enumToOptions(permittedLanguageNames),
    data => data?.permittedLanguages?.map(String)
);
function groupPermissionsByPrefix(permissions) {
    const groups = new Map();
    permissions.forEach(permission => {
        const prefix = String(permission.name ?? '').split('.')[0];
        if (!groups.has(prefix)) groups.set(prefix, []);
        groups.get(prefix).push(permission);
    });
    return [...groups.entries()]
        .sort(([a], [b]) => a.localeCompare(b, undefined, { sensitivity: 'base' }))
        .map(([, items]) => items);
}

export const setupPermissionsDropdown = createDropdownInit(
    async () => groupPermissionsByPrefix((await apiFetch("Permissions")) ?? []),
    data => data?.permissionId ? String(data.permissionId).split(";").map(permission => permission.trim()).filter(Boolean) : undefined
);
export const setupActivitiesDropdown = createDropdownInit(
    async () => enumToOptions(teamActivities),
    data => data?.activityId ? String(data.activityId).split(";").map(activityId => activityId.trim()).filter(Boolean) : undefined
);
export const setupEmploymentTypeDropdown = createDropdownInit(
    async () => enumToOptions(employmentTypes),
    data => data?.employmentType != null ? String(data.employmentType) : undefined
);
export const setupMembersDropdown = createDropdownInit(
    async () => ((await apiFetch("users")) ?? []).map(user => ({ id: user.id, name: user.name })),
    data => data?.memberId ? String(data.memberId).split(" ").filter(Boolean) : undefined
);